import type { OutputFormat } from './floorPlan.types';

export type RawDiagramPage = {
  page: string;
  count: number;
  breaker_ids?: string[];
  breakerIds?: string[];
};

export type RawDiagramRef = {
  diagram: string | { id: string; name: string };
  count: number;
  pages?: RawDiagramPage[];
};

export type RawDiagramLvMatch = {
  lvId?: string;
  lvName?: string;
  confidence?: string;
  reasoning?: string;
};

export type RawDiagramItem = {
  item: string;
  text?: string;
  quantity?: number;
  unit?: string;
  diagrams?: RawDiagramRef[];
  lvMatch?: RawDiagramLvMatch;
};

export type TransformedDiagramPage = {
  page: string;
  count: number;
  breakerIds: string[];
};

export type TransformedDiagramDiagram = {
  diagram: string | { id: string; name: string };
  count: number;
  pages: TransformedDiagramPage[];
};

export type TransformedDiagramLvMatch = {
  lvId?: string;
  lvName?: string;
  confidence?: string;
  reasoning?: string;
};

export type TransformedDiagramItem = {
  item: string;
  text: string;
  quantity: number;
  unit: string;
  diagrams: TransformedDiagramDiagram[];
  lvMatch?: TransformedDiagramLvMatch;
};

export type ImportDiagramPageInfo = {
  diagramKey: string;
  pageFilename: string;
  imagePath: string;
  pageIndex: number;
};

export type ImportDiagramPdfInfo = {
  diagramKey: string;
  pdfPath: string;
};

export type ImportDiagramItemsPayload = {
  items: TransformedDiagramItem[];
  pages: ImportDiagramPageInfo[];
  pdfs: ImportDiagramPdfInfo[];
};

export type DiagramPageImageInfo = {
  file: File;
  naturalWidth: number;
  naturalHeight: number;
};

export type DiagramFileSettings = {
  pdfFile: File | null;
  pageImages: Record<number, DiagramPageImageInfo | null>;
  scaleFactor: number;
  quality: number;
  outputFormat: OutputFormat;
};

export const EMPTY_DIAGRAM_FILE_SETTINGS: DiagramFileSettings = {
  pdfFile: null,
  pageImages: {},
  scaleFactor: 1,
  quality: 100,
  outputFormat: 'webp',
};

export type DiagramInfo = {
  name: string;
  pages: Set<string>;
  itemCount: number;
  occurrenceCount: number;
};
